module.exports = __webpack_public_path__ + "img/empty-wish.ff94cf11.svg";